// AUTO-GENERATED by scripts/generate-build-info.js at build time.
// DO NOT EDIT and DO NOT COMMIT — this file is git-ignored.
export const BUILD_INFO = {
  version: '0.1.0',
  commit: '9bdcbc5',
  branch: 'HEAD',
  buildTime: '2026-10-09T07:12:10.707Z',
} as const
